import React, { useState } from "react";
import { Badge, Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import PageToolbar from "../../../../design-system/PageToolbar";
import { useIsMobile } from "../../../../design-system/useMediaQuery";

/**
 * PageToolbar for accounting lists.
 *   search       always-visible primary filter (e.g. Input.Search)
 *   filters      further filters; inline on tablet/desktop, behind a "Filters" toggle on phones
 *   activeCount  number of non-default filters, shown on the phone toggle
 *   actions      buttons at the end (full-width row on phones)
 */
const FilterToolbar = ({ search, filters, activeCount = 0, actions }) => {
  const { t } = useTranslation("accounting");
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  const hasFilters = Boolean(filters);
  const toggle =
    isMobile && hasFilters ? (
      <Button
        icon={<FilterOutlined />}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        type={open ? "primary" : "default"}
        ghost={open}
      >
        {t("Filters")} {activeCount ? <Badge count={activeCount} size="small" /> : null}
      </Button>
    ) : null;

  const panel =
    hasFilters && (!isMobile || open) ? <div className="acct-filter-panel">{filters}</div> : null;

  return (
    <PageToolbar
      filters={
        search || panel || toggle ? (
          <>
            {search}
            {toggle}
            {panel}
          </>
        ) : null
      }
      actions={actions}
    />
  );
};

export default FilterToolbar;
